module.exports = __webpack_public_path__ + "img/logo.f1c1477f.png";